import { render, staticRenderFns } from "./ai-win.vue?vue&type=template&id=22faff0c&scoped=true"
import script from "./ai-win.vue?vue&type=script&lang=js"
export * from "./ai-win.vue?vue&type=script&lang=js"
import style0 from "./ai-win.vue?vue&type=style&index=0&id=22faff0c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22faff0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22faff0c')) {
      api.createRecord('22faff0c', component.options)
    } else {
      api.reload('22faff0c', component.options)
    }
    module.hot.accept("./ai-win.vue?vue&type=template&id=22faff0c&scoped=true", function () {
      api.rerender('22faff0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/chat/ai-win.vue"
export default component.exports